import React, { useState } from 'react'
import {
  Box,
  Typography,
  Grid,
  ButtonBase,
  Menu,
  MenuItem,
} from '@mui/material'
import MpSvgIcon from '../atom/MpSvgIcon'
import ConfirmationModal from '../atom/ConfirmationModal'
import { EmployeeRow } from './DashboardGrid'
import IndividualUserStats from '../atom/IndividualUserStats'

type Props = {
  rows: EmployeeRow[]
  openMenuIndex: number | null
  anchorEl: HTMLButtonElement | null
  isOpen: boolean
  handleButtonClick: (event: React.MouseEvent<HTMLButtonElement>, index: number) => void
  close: () => void
  handleopen: () => void
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  muidrow: string | null
  buttonRef: React.RefObject<HTMLButtonElement>
  dispatch: any
  resendInvite: (muid: string) => void
}

const EmployeeMobileView: React.FC<Props> = ({
  rows,
  openMenuIndex,
  anchorEl,
  isOpen,
  handleButtonClick,
  close,
  handleopen,
  open,
  setOpen,
  muidrow,
  buttonRef,
  dispatch,
  resendInvite,
}) => {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)
  const [userMuid, setUserMuid] = useState<string | null>(null)
  const columns = [
    { key: 'col1', name: 'Email ID' },
    { key: 'col2', name: 'Found' },
    { key: 'col3', name: 'Removed' },
    { key: 'col4', name: 'In Progress' },
  ]

  return (
    <Box bgcolor="#fff" borderRadius={5} p={3}>
      <Typography variant="h3" mx={2} mt={2}>
        Removal stats
      </Typography>
      {rows.map((row) => (
        <Grid
          key={row.id}
          container
          direction="row"
          spacing={2}
          sx={{ borderBottom: '1px solid #615F6B', padding: 2, position: 'relative' }}>
          <Box
            sx={{
              backgroundColor: openMenuIndex === row.id ? '#ECF0FD' : 'white',
              borderRadius: '2px',
              position: 'absolute',
              top: '12px',
              right: '12px',
            }}
          >
            {row.col5 !== 'deleted' && (
              <ButtonBase
                sx={{ borderRadius: '10px' }}
                type="button"
                onClick={(event) => handleButtonClick(event, row.id)}
                ref={buttonRef}
                aria-controls={isOpen ? 'simple-menu' : undefined}
                aria-expanded={isOpen || undefined}
                aria-haspopup="menu">
                <MpSvgIcon
                  icon={
                    openMenuIndex === row.id ? 'threeDotsBlue' : 'threeDotsNew'
                  }
                />
              </ButtonBase>
            )}
            <Menu
              open={openMenuIndex === row.id}
              onClose={close}
              anchorEl={anchorEl}
              PaperProps={{
                style: { backgroundColor: '#ECF0FD'},
              }}
              sx={{ borderRadius: '20px', opacity: 1 }}
            >
              <MenuItem
                onClick={() => {
                  setDetailsModalOpen(true)
                  if (row.col8) setUserMuid(row.col8)
                  close()
                }}
              >
                <Typography variant="label" color="#1A1B20">
                  View Details
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleopen()
                  close()
                }}
              >
                <Typography variant="label" color="#1A1B20">
                  Remove Employee
                </Typography>
              </MenuItem>
              {row.col5 === 'invited' && (
                <MenuItem
                  disabled={!row.col8}
                  onClick={() => row.col8 && dispatch(resendInvite(row.col8))}
                >
                  <Typography variant="label" color="#1A1B20">
                    Resend Invitation
                  </Typography>
                </MenuItem>
              )}
            </Menu>
            <ConfirmationModal open={open} setOpen={setOpen} muid={muidrow} />
          </Box>
          {columns.map((col) => (
            <Grid item key={col.key} xs={6}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  wordWrap: 'break-word',
                }}
              >
                <Typography variant="h5">{col.name}</Typography>
                <Typography
                  variant="label"
                  sx={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {row[col.key as keyof EmployeeRow]}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      ))}
      <IndividualUserStats
        open={detailsModalOpen}
        setOpen={setDetailsModalOpen}
        muid={userMuid}
        setMuid={setUserMuid}
      />
    </Box>
  )
}

export default EmployeeMobileView
